import React, { useState } from "react";
import { useTenantContent } from "../../Context/TenantContentContext";
import ServiceModal from "./ServiceModal";

const SERVICE_ICON_FALLBACKS = {
  "پرتودرمانی پیشرفته": "/icons/radiotherapy.svg",
  "درمان سیستمیک سرطان": "/icons/systemic-therapy.svg",
  "مشاوره آنلاین": "/icons/online-consult.svg",
};

const resolveServiceIcon = (service) =>
  service?.iconUrl || SERVICE_ICON_FALLBACKS[service?.title] || "";

const ServiceCards = () => {
  const { content } = useTenantContent();
  const [showAll, setShowAll] = useState(false);

  if (!content || !content.services || content.services.length === 0) {
    return null;
  }

  const services = content.services;
  const visibleServices = showAll ? services : services.slice(0, 3);

  return (
    <div className="container py-4 iran-sans">
      <div className="row justify-content-center d-flex">
        {visibleServices.map((service, index) => {
          const modalId = service.title.replace(/\s+/g, "-");
          const iconSrc = resolveServiceIcon(service);
          return (
            <div className="col-md-4 col-sm-12 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0 text-center bg-light service-card">
                <div className="card-body">
                  <div className="mb-3 mt-3 justify-content-center d-flex">
                    {iconSrc ? (
                      <img
                        src={iconSrc}
                        alt=""
                        loading="lazy"
                        style={{
                          width: "100px",
                          height: "100px",
                          padding: "15px",
                        }}
                      />
                    ) : null}
                  </div>
                  <hr className=" ms-4 me-4 pt-3 mt-2 color-green" />
                  <h5 className="fw-bold mb-3 color-blue">{service.title}</h5>
                  <p className="text-muted pt-2 pe-3 ps-3 mb-4">
                    {service.description}
                  </p>
                  <button
                    type="button"
                    className="fw-bold text-decoration-none color-green bg-transparent border-0 p-0 home-topic mb-2"
                    data-bs-toggle="modal"
                    style={{ fontSize: "18px", fontFamily: "GT-super" }}
                    data-bs-target={`#${modalId}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="fs-6">ادامه</span>
                  </button>
                </div>
              </div>

              <ServiceModal
                id={modalId}
                title={service.title}
                description={service.fullDescription}
                icon={iconSrc}
              />
            </div>
          );
        })}
      </div>

      {services.length > 3 && (
        <div className="row justify-content-center d-flex">
          <div className="col justify-content-center d-flex gap-2">
            {!showAll ? (
              <button
                className="btn-clear mt-0 fw-bold rounded-5 iran-sans"
                onClick={() => setShowAll(true)}
              >
                مشاهده بیشتر
              </button>
            ) : (
              <button
                className="btn-clear mt-0 fw-bold rounded-5 iran-sans"
                onClick={() => setShowAll(false)}
              >
                نمایش کمتر
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceCards;
